import React,{PureComponent} from 'react'
import styled from 'styled-components'
import {BLUE, LIGHT_BLUE} from '../colors'

const StyledToolbar = styled.div`
    display:flex;
    align-items:center;
    h1{
        color:${BLUE};
        font-size:28px;
        margin-right: 50px;
        font-weight:300;
    }
    .meta{
        color:${LIGHT_BLUE};
        font-size:15px;
    }
    .controls{
        
        margin-left:auto;
        min-width:50%;
        display:flex;
        align-items:center;
        justify-content:flex-end;
        & > *{
            margin: 0 5px;
        }
    }
`

export default class Toolbar extends PureComponent{
    render(){
        const {title, meta, controls} = this.props
        return <StyledToolbar>
            <h1>{title}</h1>
            <div className="meta">
                {meta}
            </div>  
            <div className="controls">
                {controls}
            </div>
        </StyledToolbar>
    }
}


// WEBPACK FOOTER //
// ./src/components/app/toolbar.js